import React from 'react'
import Onboarding from '../../Components/DMM/Onboarding/Onboarding'

const index = props => {
  return <Onboarding />
}

export default index
